import { SettingsCard, ToggleField, TextAreaField } from "./fields";
import type { SettingsTabProps } from "../settings";

export default function Gelismis({ settings, update }: SettingsTabProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <SettingsCard
        title="Bakım Modu"
        description="Siteyi geçici olarak ziyaretçilere kapatın. Yöneticiler siteye erişmeye devam eder."
      >
        <div className="space-y-3">
          <ToggleField
            label="Bakım modunu etkinleştir"
            description="Etkinleştirildiğinde ziyaretçiler bakım mesajını görür."
            checked={settings.maintenanceMode}
            onChange={(v) => update({ maintenanceMode: v })}
          />
          <TextAreaField
            label="Bakım mesajı"
            value={settings.maintenanceMessage}
            onChange={(v) => update({ maintenanceMessage: v })}
            placeholder="Ziyaretçilere gösterilecek mesaj"
            rows={3}
          />
        </div>
      </SettingsCard>

      <SettingsCard
        title="Analiz & İzleme"
        description="Platform içi ölçüm ve istatistik ayarları."
      >
        <div className="space-y-3">
          <ToggleField
            label="Analiz takibi"
            description="Kullanım istatistikleri ve öğrenci ilerleme verileri toplanır."
            checked={settings.analyticsEnabled}
            onChange={(v) => update({ analyticsEnabled: v })}
          />
        </div>
      </SettingsCard>
    </div>
  );
}